import React, { FC, useState } from "react";
import { t } from "i18next";

import CardGuide from "@components/common/CardGuide/CardGuide";

interface VsmeGuide {
  steps: CardGuide["steps"];
}

const VsmeGuide: FC<VsmeGuide> = ({ steps }) => {
  const [activeStep, setActiveStep] = useState<CardGuide["active"]>(0);
  const [clicked, setClicked] = useState<CardGuide["clicked"]>();

  const handleStepClick = (index: number): void => {
    if (activeStep === index) {
      setActiveStep(0);
    } else {
      setActiveStep(index);
    }
    if (!clicked?.[index]) {
      setStepClicked(index);
    }
  };

  const setStepClicked = (index: number): void => {
    const newClicked = clicked
      ? clicked.map((c, i) => (i === index ? true : c))
      : steps.map((s, i) => i === index);

    setClicked(newClicked);
  };

  return (
    <CardGuide
      title={t("vsme.guide.title")}
      titleTooltip={t("vsme.guide.text")}
      onClickStep={handleStepClick}
      active={activeStep}
      steps={steps}
      clicked={clicked}
    />
  );
};

export default VsmeGuide;
